import axios from "axios"
import { authHeader } from "./auth-header"

const instance = axios.create({
	headers: authHeader(),
	timeout: 5000,
})

instance.interceptors.response.use(
	(config) => config,
	(error) => {
		// if (
		// 	error.response &&
		// 	error.response.status === 401 &&
		// 	sessionStorage.getItem("user") != null
		// ) {
		// 	sessionStorage.removeItem("user")
		// 	sessionStorage.removeItem("accessToken")
		// 	window.location.reload()
		// }

		if (error.message.includes("401")) {
			return Promise.reject("Incorrect email or password")
		}
		return Promise.reject(error)
	}
)

export default instance
